import moment from "moment";
export const isPastDateTime = (date, time) => {
    if(date){
        let selectedDateTime =  moment(moment(date)?.format('YYYY-MM-DD') + ' ' + time, 'YYYY-MM-DD HH:mm');
        let isPastDateTime = selectedDateTime.isBefore(moment());
        return isPastDateTime;
    }else{
        return null
    }
};